export default __webpack_public_path__ + "logo.light.1350168b520191e6f8167d0397cde51f.svg";